(function () {
    "use strict";

    angular
        .module("app.location")
        .controller("LocationController", LocationController);

    LocationController.$inject = [
        "LocationService",
        "GeneralService",
        "$window",
        "$scope",
        "$timeout",
        "$cookies",
    ];

    function LocationController(
        LocationService,
        GeneralService,
        $window,
        $scope,
        $timeout,
        $cookies
    ) {
        var vm = this;
        vm.location = {};
        vm.loading = true;
        vm.newDeliveryLocation = {};
        vm.useLocationAddress = "Teslimat Noktası Seç";
        // $(".select-location-mobile .selected-location-name").text(vm.useLocationAddress);

        function activate() {
            vm.loading = true;

            //ülke seçimi disable bir alan olduğu için dropdownu dolduruyoruz
            vm.getCountry();

            //eğer kullanıcı önceden teslimat noktası kaydetmiş ise isimleri bu değişkende tutulur
            var deliveryAddressNames = JSON.parse(
                $window.localStorage["deliveryAddressNames"] || null
            );

            if (deliveryAddressNames != null) {
                //kayıtlı noktanın idleri bu değişkende tutulur
                var deliveryAddressIds = JSON.parse(
                    $window.localStorage["deliveryAddressIds"] || "{}"
                );

                if (deliveryAddressIds) {
                    //idler için
                    vm.newDeliveryLocation = deliveryAddressIds;

                    //isimler için
                    vm.useLocationAddress =
                        deliveryAddressNames.StateProvince.charAt(
                            0
                        ).toUpperCase() +
                        deliveryAddressNames.StateProvince.slice(1) +
                        ", " +
                        deliveryAddressNames.District.charAt(0).toUpperCase() +
                        deliveryAddressNames.District.slice(1) +
                        ", " +
                        (deliveryAddressNames.City
                            ? deliveryAddressNames.City.charAt(
                                  0
                              ).toUpperCase() +
                              deliveryAddressNames.City.slice(1)
                            : "");

                    // $(".select-location-mobile .selected-location-name").text(vm.useLocationAddress);
                }
            }

            vm.loading = false;
        }

        vm.getCountry = function () {
            LocationService.getCountry().then(function (response) {
                vm.countries = response.sort(function (a, b) {
                    return a.Name.localeCompare(b.Name);
                });

                vm.newDeliveryLocation.CountryId = vm.countries.find(
                    (t) => TurkishCharacterToEnglish(t.Code) == "tr"
                ).Id;
                vm.getCountryChange();
            });
        };

        //eğer ülke değişirse illeri onagöre çekmek için
        vm.getCountryChange = async function () {
            if (vm.newDeliveryLocation.CountryId) {
                await LocationService.getStateProvince(
                    vm.newDeliveryLocation.CountryId
                ).then(function (response) {
                    vm.getStateProvince = response.sort((a, b) =>
                        a.Name.localeCompare(b.Name)
                    );
                });
                vm.getStateProvinceChange();
            }
        };

        //eğer il değişirse ilçeleri çeker
        vm.getStateProvinceChange = async function () {
            if (vm.newDeliveryLocation.StateProvinceId) {
                await LocationService.getDistrict(
                    vm.newDeliveryLocation.StateProvinceId
                ).then(function (response) {
                    vm.getDistrict = response.sort((a, b) =>
                        a.Name.localeCompare(b.Name)
                    );
                });
                vm.getDistrictChange();
            }
        };

        //eğer ilçe değişirse mahalleleri çeker
        vm.getDistrictChange = async function () {
            if (vm.newDeliveryLocation.DistrictId) {
                await LocationService.getCity(
                    vm.newDeliveryLocation.DistrictId
                ).then(function (response) {
                    vm.getCity = response.sort((a, b) =>
                        a.Name.localeCompare(b.Name)
                    );
                });
            }
        };

        vm.saveLocation = function () {
            vm.loading = true;

            var deliveryAddressIds = JSON.parse(
                $window.localStorage["deliveryAddressIds"] || null
            );

            $window.localStorage["deliveryAddressIds"] = JSON.stringify(
                vm.newDeliveryLocation
            );
            $cookies.put(
                "deliveryAddressIds",
                JSON.stringify(vm.newDeliveryLocation)
            );
            vm.getWarehouseIds();

            //adreslerin isimlerinin locale yazılması
            let addressNames = {
                StateProvince: vm.getStateProvince.find(
                    (x) => x.Id == vm.newDeliveryLocation.StateProvinceId
                ).Name,
                District: vm.getDistrict.find(
                    (x) => x.Id == vm.newDeliveryLocation.DistrictId
                ).Name,
                City: vm.getCity.find(
                    (x) => x.Id == vm.newDeliveryLocation.CityId
                ).Name,
            };

            $window.localStorage.setItem(
                "deliveryAddressNames",
                JSON.stringify(addressNames)
            );

            if (deliveryAddressIds) {
                if (
                    deliveryAddressIds.StateProvinceId !=
                        vm.newDeliveryLocation.StateProvinceId ||
                    deliveryAddressIds.DistrictId !=
                        vm.newDeliveryLocation.DistrictId ||
                    deliveryAddressIds.CityId != vm.newDeliveryLocation.CityId
                ) {
                    vm.loading = false;
                    $.Cart.RemoveCartAllProduct();
                }
            }
            vm.loading = false;
        };

        vm.getWarehouseIds = function () {
            LocationService.getWarehouseIds(vm.newDeliveryLocation)
                .then(function (response) {
                    vm.warehousees = response.Data;
                    var warehouseId = vm.warehousees[0]
                        ? vm.warehousees[0].Id
                        : null;
                    vm.newDeliveryLocation.WarehouseId = warehouseId;
                    $window.localStorage["deliveryAddressIds"] = JSON.stringify(
                        vm.newDeliveryLocation
                    );
                    $cookies.put(
                        "deliveryAddressIds",
                        JSON.stringify(vm.newDeliveryLocation)
                    );
                    $window.location.reload();
                })
                .catch(function (error) {
                    console.error(error);
                });
        };

        vm.getLocation = function () {
            function errorHandler(err) {
                if (err.code == 1) {
                    alert(
                        "Hata: Konum erişimi izni verilmedi! Lütfen izin verdikten sonra terar deneyiniz."
                    );
                } else if (err.code == 2) {
                    alert("Hata: Konum kullanılamaz!");
                }
            }
            function getLocation() {
                if (navigator.geolocation) {
                    var options = { timeout: 5000 };
                    navigator.geolocation.getCurrentPosition(
                        showPosition,
                        errorHandler,
                        options
                    );
                } else {
                    alert(
                        "Hata, tarayıcınız otamatik konum almayı desteklememektedir! Lütfen tarayıcınızı güncelleyiniz yada farklı bir tarayıcı kullanınız."
                    );
                }
            }

            getLocation();
        };

        function showPosition(position) {
            var lat = position.coords.latitude;
            var lng = position.coords.longitude;

            // get request link
            var requestPromise = new Promise(function (resolve, reject) {
                $.ajax(
                    "https://nominatim.openstreetmap.org/search?q=" +
                        lat +
                        "," +
                        lng +
                        "&format=geojson&accept-language=tr&addressdetails=1",
                    {
                        type: "GET",
                        success: function (data) {
                            var address = data.features[0].properties.address;

                            var country = TurkishCharacterToEnglish(
                                address.country_code
                            );

                            var stateprovince = TurkishCharacterToEnglish(
                                address.province
                            );

                            var district = TurkishCharacterToEnglish(
                                address.town ? address.town : address.county
                            );

                            var city = TurkishCharacterToEnglish(
                                address.suburb ? address.suburb : address.city
                            );

                            var mapAddress = {
                                Country: country,
                                StateProvince: stateprovince,
                                District: district,
                                City: city,
                            };

                            $window.localStorage.setItem(
                                "deliveryAddressNames",
                                JSON.stringify(mapAddress)
                            );
                            vm.useLocationAddress =
                                address.province +
                                ", " +
                                (address.town ? address.town : address.county) +
                                ", " +
                                (address.suburb
                                    ? address.suburb
                                    : address.city);
                            resolve(mapAddress);
                            // $(".select-location-mobile .selected-location-name").text(vm.useLocationAddress);
                        },
                        error: function (error) {
                            reject(error);
                        },
                    }
                );
            });

            requestPromise
                .then(function (result) {
                    var getCountryPromise = LocationService.getCountry();

                    getCountryPromise.then(function (response) {
                        vm.countries = response;

                        vm.newDeliveryLocation.CountryId = vm.countries.find(
                            (t) =>
                                TurkishCharacterToEnglish(t.Code) ==
                                result.Country
                        ).Id;

                        var getStatePromise = LocationService.getStateProvince(
                            vm.newDeliveryLocation.CountryId
                        );

                        getStatePromise.then(function (response) {
                            vm.getStateProvince = response;

                            vm.newDeliveryLocation.StateProvinceId =
                                vm.getStateProvince.find(
                                    (t) =>
                                        TurkishCharacterToEnglish(t.Name) ==
                                        result.StateProvince
                                ).Id;
                            vm.getStateProvinceChange(
                                vm.newDeliveryLocation.StateProvinceId
                            );

                            var getDistrictPromise =
                                LocationService.getDistrict(
                                    vm.newDeliveryLocation.StateProvinceId
                                );

                            getDistrictPromise.then(function (response) {
                                vm.getDistrict = response;
                                vm.getCity = null;

                                vm.newDeliveryLocation.DistrictId =
                                    vm.getDistrict.find(
                                        (t) =>
                                            TurkishCharacterToEnglish(t.Name) ==
                                            result.District
                                    ).Id;
                                vm.getDistrictChange(
                                    vm.newDeliveryLocation.DistrictIdId
                                );

                                var getCityPromise = LocationService.getCity(
                                    vm.newDeliveryLocation.DistrictId
                                );

                                getCityPromise.then(function (response) {
                                    vm.getCity = response;

                                    vm.newDeliveryLocation.CityId =
                                        vm.getCity.find((t) =>
                                            result.City.contains(
                                                TurkishCharacterToEnglish(
                                                    t.Name
                                                )
                                            )
                                        ).Id;
                                });
                            });
                        });
                    });
                })
                .catch(function (error) {
                    alert(
                        "Lokasyon bilgisi alınırken sorun oluştu lütfen tekrar deneyiniz.",
                        error
                    );
                });
        }

        function TurkishCharacterToEnglish(text) {
            if (text) {
                text = text.trim().replace(/[-]+/gi, "-").toLowerCase("tr");
                var trMap = {
                    çÇ: "c",

                    ğĞ: "g",

                    şŞ: "s",

                    üÜ: "u",

                    ıİ: "i",

                    öÖ: "o",
                };

                for (var key in trMap) {
                    text = text.replace(
                        new RegExp("[" + key + "]", "g"),
                        trMap[key]
                    );
                }

                return text.replace(/[^-a-zA-Z0-9\s]+/gi, ""); // remove non-alphanumeric chars
            }
            return text;
        }

        activate();
    }
})();
